import { useFocusInvalidField } from "@shared/hooks/useFocusInvalidField";
import { FormElementAttributes } from "@types";
import classNames from "classnames";
import { Field } from "formik";
import { useFormContext } from "./form-context";

interface Props extends FormElementAttributes {
  hasError?: boolean;
}

const NumberInput: React.FC<Props> = (props) => {
  const { commonAttrs, classes, hasError } = props;
  const { name, id, min, max, placeholder } = commonAttrs;
  const { validate } = useFormContext();
  const { fieldRef } = useFocusInvalidField(name, true);
  return (
    <Field
      type={"number"}
      name={name}
      validate={(v: any) => validate(name, v)}
      className={classNames(
        classes.join(" "),
        "form-control",
        hasError ? "form-error-validation" : ""
      )}
      id={id}
      min={min ? parseInt(min) : undefined}
      max={max ? parseInt(max) : undefined}
      placeholder={placeholder}
      innerRef={(el: HTMLElement) => {
        fieldRef.current = el;
      }}
    />
  );
};

export default NumberInput;
